module.exports = __webpack_public_path__ + "img/preview.c7111525.jpeg";